import React, { FC } from 'react'

export const Icon6: FC = () => (
  <svg
    width="135"
    height="137"
    viewBox="0 0 135 137"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.46056 108.83V9.2891H98.4921V55.4491C100.614 51.9784 103.517 49.078 106.98 46.8831V5.04127C106.98 2.7045 105.066 0.792107 102.736 0.792107H5.21654C2.88628 0.792107 0.972656 2.7045 0.972656 5.04127V113.079C0.972656 115.485 2.88628 117.325 5.21654 117.325H72.6379C72.7941 116.899 72.9243 116.546 73.1456 116.122C71.0887 113.926 69.4615 111.447 68.2508 108.83H9.46056Z"
      fill="#262A44"
    />
    <path
      d="M80.8531 23.3659H27.0627C24.7178 23.3659 22.824 25.2676 22.824 27.6112C22.824 29.9548 24.7178 31.8564 27.0627 31.8564H80.8531C83.198 31.8564 85.092 29.9548 85.092 27.6112C85.092 25.2676 83.198 23.3659 80.8531 23.3659Z"
      fill="#262A44"
    />
    <path
      d="M80.8531 44.3433H27.0627C24.7178 44.3433 22.824 46.2437 22.824 48.5873C22.824 50.9309 24.7178 52.8325 27.0627 52.8325H80.8531C83.198 52.8325 85.092 50.9309 85.092 48.5873C85.092 46.2437 83.198 44.3433 80.8531 44.3433Z"
      fill="#262A44"
    />
    <path
      d="M27.0953 65.3609C24.756 65.3609 22.8408 67.2002 22.8408 69.537C22.8408 71.9471 24.756 73.7852 27.0953 73.7852H73.2781C75.2576 70.8121 77.5327 68.0499 80.142 65.3609H27.0953Z"
      fill="#262A44"
    />
    <path
      d="M65.6416 94.8125C65.7821 92.0494 66.3442 89.1459 67.2001 86.3151H27.1019C24.7642 86.3151 22.8481 88.2261 22.8481 90.5638C22.8481 92.9002 24.7642 94.8125 27.1019 94.8125H65.6416Z"
      fill="#262A44"
    />
    <path
      d="M130.476 44.3335C125.754 46.511 119.411 49.6249 112.315 53.5698C108.807 55.5165 106.063 58.5856 104.494 62.2785C101.183 70.0217 97.042 82.4009 95.7759 90.6137C95.6704 91.3984 94.5757 91.5435 94.2855 90.8036C91.7005 84.122 91.4367 75.4133 91.8587 69.1881C91.9247 68.0236 90.5662 67.3602 89.6694 68.1133C73.4074 81.8364 67.4327 103.536 83.642 113.841C80.0282 120.827 76.2958 130.576 74.7658 134.711C74.4229 135.665 75.122 136.671 76.1507 136.671H81.1492C81.7559 136.671 82.31 136.29 82.5078 135.716C83.5102 132.989 86.6096 124.875 90.5926 117.204C108.582 124.062 121.415 116.395 125.214 82.4075C127.245 64.0998 130.753 53.6291 133.747 47.735C134.815 45.6155 132.639 43.3378 130.476 44.3335Z"
      fill="#4E97EA"
    />
  </svg>
)
